<div class="showcase-grid">
  <div class="showcase-row" data-showcase-id="cs-badge">
    <cs-label>cs-badge: every colour</cs-label>
    <div class="showcase-variants">
      @for (color of badgeColors; track color) {
        <cs-badge icon="time" [label]="color | untranslated" [info]="'3' | untranslated" [color]="color"></cs-badge>
      }
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-text-alert">
    <cs-label>cs-text-alert: every type</cs-label>
    @for (type of textAlertTypes; track type) {
      <cs-text-alert [type]="type" [message]="('Text alert: ' + type) | untranslated"></cs-text-alert>
    }
  </div>

  <div class="showcase-row" data-showcase-id="cs-info-card">
    <cs-label>cs-info-card: every type (the first has an action button)</cs-label>
    @for (type of infoCardTypes; track type; let first = $first) {
      <cs-info-card [type]="type" [message]="('Info card: ' + type) | untranslated"
        [actionText]="first ? ('Fix It' | untranslated) : undefined"></cs-info-card>
    }
  </div>

  <div class="showcase-row" data-showcase-id="cs-empty-state">
    <cs-label>cs-empty-state</cs-label>
    <cs-empty-state iconName="search" [title]="'Nothing Here Yet' | untranslated"
      [subtext]="'Try a different search.' | untranslated"></cs-empty-state>
  </div>

  <div class="showcase-row" data-showcase-id="cs-skeleton">
    <cs-label>cs-skeleton (loading placeholders) and cs-spinner</cs-label>
    <cs-skeleton width="80%"></cs-skeleton>
    <cs-skeleton width="50%"></cs-skeleton>
    <!-- the spinner is off until asked for: a cs-spinner anywhere on a page tells the E2E page-load
         wait that the page is still loading -->
    <div class="showcase-variants">
      <cs-button small secondary (click)="showSpinner = !showSpinner"
        [label]="(showSpinner ? 'Hide Spinner' : 'Show Spinner') | untranslated" data-test="toggle-showcase-spinner"></cs-button>
      @if (showSpinner) {
        <cs-spinner></cs-spinner>
      }
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-stepper">
    <cs-label>cs-stepper: streamlined, traditional</cs-label>
    <cs-stepper [totalSteps]="5" [currentStep]="2"></cs-stepper>
    <cs-stepper [steps]="stepperSteps" [style]="StepperStyle.Traditional"></cs-stepper>
  </div>

  <div class="showcase-row" data-showcase-id="cs-status-icon">
    <cs-label>cs-status-icon: done, in progress, success, neutral (large), then success and neutral (small)</cs-label>
    <div class="showcase-variants">
      <cs-status-icon [tone]="StatusIconTone.Done"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.InProgress" icon="time"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.Success"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.Neutral"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.Success" [size]="StatusIconSize.Small" icon="checkmark"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.Neutral" [size]="StatusIconSize.Small" icon="checkmark"></cs-status-icon>
    </div>
    <cs-label>the set marks (small, icon in the text colour): success, warning, assertive</cs-label>
    <div class="showcase-variants">
      <cs-status-icon [tone]="StatusIconTone.Success" [size]="StatusIconSize.Small" icon="checkmark" [textIcon]="true"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.Warning" [size]="StatusIconSize.Small" icon="remove" [textIcon]="true"></cs-status-icon>
      <cs-status-icon [tone]="StatusIconTone.Assertive" [size]="StatusIconSize.Small" icon="arrow-down" [textIcon]="true"></cs-status-icon>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-exercise-status-badge">
    <cs-label>cs-exercise-status-badge: number, in progress, complete, complete filled</cs-label>
    <div class="showcase-variants">
      <cs-exercise-status-badge [type]="ExerciseStatusBadgeType.Number" number="2a"></cs-exercise-status-badge>
      <cs-exercise-status-badge [type]="ExerciseStatusBadgeType.InProgress"></cs-exercise-status-badge>
      <cs-exercise-status-badge [type]="ExerciseStatusBadgeType.Complete"></cs-exercise-status-badge>
      <cs-exercise-status-badge [type]="ExerciseStatusBadgeType.Complete" [filled]="true"></cs-exercise-status-badge>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-rep-progress-bar">
    <cs-label>cs-rep-progress-bar: neutral, progress</cs-label>
    <cs-rep-progress-bar [min]="6" [max]="12" [fillFrom]="6" [fillTo]="9"></cs-rep-progress-bar>
    <cs-rep-progress-bar [min]="6" [max]="12" [fillFrom]="6" [fillTo]="9" [markerAt]="10"
      [markerLabel]="'Target' | untranslated" [showFillLabels]="true" [tone]="RepProgressBarTone.Progress"></cs-rep-progress-bar>
    <cs-label>with a dot at today's reps, and a narrow range whose labels merge into "15–16"</cs-label>
    <cs-rep-progress-bar [min]="0" [max]="16" [fillFrom]="15" [fillTo]="16" [markerAt]="14" [dotAt]="16" [dotTone]="RepProgressBarTone.Progress"
      [markerLabel]="'last · 14' | untranslated" [showFillLabels]="true" [mergeFillLabels]="true" [sliderLook]="true"
      [tone]="RepProgressBarTone.Progress"></cs-rep-progress-bar>
    <cs-label>a range so narrow that its labels merge at any width ("99–100", checked by E2E)</cs-label>
    <cs-rep-progress-bar data-e2e-id="e2e-test-merged-bar" [min]="0" [max]="100" [fillFrom]="99" [fillTo]="100"
      [showFillLabels]="true" [mergeFillLabels]="true" [sliderLook]="true"></cs-rep-progress-bar>
  </div>

  <div class="showcase-row" data-showcase-id="cs-scanner-progress-bar">
    <cs-label>cs-scanner-progress-bar</cs-label>
    <cs-scanner-progress-bar [progress]="60"></cs-scanner-progress-bar>
  </div>

  <div class="showcase-row" data-showcase-id="cs-coach-banner">
    <cs-label>cs-coach-banner</cs-label>
    <cs-coach-banner clientDisplayName="Jane Doe" [clientOnline]="true"></cs-coach-banner>
  </div>

  <div class="showcase-row" data-showcase-id="cs-support-card">
    <cs-label>cs-support-card</cs-label>
    <cs-support-card></cs-support-card>
  </div>
</div>
